import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('activity-list/index', {params});
    },
    getActivity(params) {
        return Service().get('activity-list/get-activity-list', {params});
    },
    show(id) {
        return Service().get('activity-list/show/'+id);
    },
    create(params) {
        return Service().post('activity-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('activity-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('activity-list/delete/'+id);
    },
}